export function formatDecimalToPrice(price) {
    var val = parseFloat(price).toFixed(2) + " €";
    val = val.replace(".", ",");
    return val;
}